import { messages } from '@/texts/messages'
import FormService from '@/services/FormService'

export default class UpdateStrategy {
  constructor() {
    this.service = new FormService()
  }

  async save(token, form, id) {
    await this.service.update(id, form, token)
    return id
  }

  async init(store, formId, token) {
    if (store.getters.formAlreadyLoaded) return

    store.commit('setFormId', formId)
    const formWithId = await this.service.getForm(formId, token)

    let form = {}
    Object.keys(formWithId).forEach((element) =>
      element !== 'id' ? (form[element] = formWithId[element]) : true
    )
    store.commit('setForm', form)
  }

  getFormTitle() {
    return messages.title_existing_form_update
  }

  getSubmitButtonText() {
    return messages.submission_existing_call
  }

  submitCallback(component) {
    return () => {
      component.$router.push({ name: 'FormsOverview' })
      component.hideModal()
    }
  }
}
